<template>
  <div class='tablePage'>
    <el-table
      stripe
      v-loading='loading'
      ref='multipleTable'
      :data='tableData'
      tooltip-effect='dark'
      style='width: 100%'
      :header-cell-style='headCellStyle'
      :height='tableHeight'
      @selection-change='handleSelectionChange'
    >
      <el-table-column type='selection' width='50' />
      <el-table-column v-if='isSys' prop='scopeName' :label="$t('public.table_scope')" show-overflow-tooltip />
      <el-table-column prop='name' :label="$t('public.table_code')" show-overflow-tooltip width='200'>
        <template #default='{ row }'>
          <DeviceCode :device='row'>
            <template #icon='{device}'>
              <i v-icon:theme="['displayTypeConvert', device.type]" v-if='!$slots.icon'></i>
            </template>
            <template #name='{device}'>
              <el-popover placement='top-start' width='auto' trigger='hover'>
                <v-popoer :rowData='device' :typeWay='$attrs.sensorWay' />
                <span slot='reference' :class="{'bolder':device.status === ENUM_DEVICE_STATUS.OFFLINE}">
                            {{ device.displayCode }}
                        </span>
              </el-popover>
            </template>
          </DeviceCode>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="sceneName" :label="$t('integration.archit.')" show-overflow-tooltip />
      <el-table-column prop="carrierName" :label="$t('integration.mount_')" show-overflow-tooltip /> -->
      <!--            <el-table-column prop="displayCode" :label="$t('integration.number')" show-overflow-tooltip />-->
      <el-table-column prop='timeCode' :label="$t('device.time_zone')" show-overflow-tooltip>
        <template #default='{ row }'>
          <span>{{ shiquFn(row.timeCode) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop='updateTime' :label="$t('public.update_time')" show-overflow-tooltip>
        <template #default='{row}'>
          {{ $timetransition(row.updateTime) }}
        </template>
      </el-table-column>
      <el-table-column prop='optare' fixed='right' :label="$t('public.table_operation')" width='160' align='center'>
        <template #default='{ row }'>
          <el-button type='text' size='small' v-for='item in optareBtn' :key='item.id' :title='$t(item.title)'
                     :icon='item.icon' @click='handle(item.method, row)'></el-button>
          <!-- v-has="item.vHas" -->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import proper from '../components/Proper.vue'
import { carrierTypeConvert, configStatusConvert, displayscreenTypeConvert, equiStatusConvert,shiquArrayConvert } from '@/utils/convert'
import DeviceCode from '@/pages/equipment/publicCom/DeviceCode.vue'
import { getPermission } from '@/utils/permission'
import { ENUM_DEVICE_STATUS } from '@/common/enum/forward/device'

export default {
  props: ['loading', 'tableData', 'shiquArray'],
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      return getPermission()
    },
    ENUM_DEVICE_STATUS: () => ENUM_DEVICE_STATUS
  },
  components: {
    DeviceCode,
    'v-popoer': proper
  },
  data () {
    return {
      displayscreenTypeConvert,
      equiStatusConvert,
      configStatusConvert,
      carrierTypeConvert,
      tableHeight: '100%',
      optareBtn: [
        {
          id: 1,
          title: $t('public.stop'),
          icon: 'el-icon-video-pause',
          vHas: [],
          method: 'stopUseFn'
        },
        {
          id: 2,
          title: $t('public.config'),
          icon: 'el-icon-setting',
          vHas: [],
          method: 'configFn'
        },
        {
          id: 3,
          title: $t('integration.pause_alarm'),
          icon: 'iconfont icon-guanbibaojing',
          vHas: [],
          method: 'stopAlarmFn'
        },
        {
          id: 4,
          title: 'public.details',
          icon: 'el-icon-tickets',
          vHas: [],
          method: 'detailFn'
        }
      ],

      isSys: true
    }
  },
  mounted () {
    if (this.sysAdmin === 'noSysIsAdmin' || this.sysAdmin === 'noSysNoAdmin') {
      this.isSys = false
    }
  },
  methods: {
    handleSelectionChange (row) {
      this.$emit('choozeTable', row)
    },
    handle (method, row) {
      this.$emit(method, row)
    },
    shiquFn (type) {
      let str = ''
      for (const item of this.shiquArray) {
        if (type === item.code) {
          str = $t(shiquArrayConvert(item.code))
          break
        }
      }
      return str
    }
  }
}
</script>

<style lang='scss' scoped>
.tablePage {
  height: calc(100% - 60px);
}
</style>
